import { TagManager } from './tagManager';

export const setDataLayer = (
	event: string,
	language: string,
	stepName?: string | null,
	accountID?: string | null,
	billingID?: string | null,
	additionalData?: any
) => {
	TagManager.dataLayer({
		dataLayer: {
			event: event,
			language: language,
			...(stepName && { stepName: stepName }),
			...(accountID && { accountID: accountID }),
			...(billingID && { billingID: billingID }),
			...additionalData,
		},
	});
};
